import { Role } from "../Permission";

export interface IAuth {
  id: string;
  email: string;
  name: string;
  country?: string;
  access_token: string;
  refresh_token: string;
  roles: Role[];
  exp?: number;
}
